import '/assets/styles/partials/lottery-branch-counts.scss';

import classNames from 'classnames';

// Partials
import Icon from '@wearetla/tla-essentials-tools/partials/icon';
import Placeholder from '/views/partials/placeholder';

// Context
import { useTranslation } from '/utilities/i18n';

// Şube bazlı çekiliş hakları (useLottery().branches). Kırmızı zemin üzerinde kullanılır.
const LotteryBranchCounts = ({ branches, loading = false, className }) => {
	const { t } = useTranslation();

	if (!branches?.length) {
		return null;
	}

	return (
		<div className={classNames('lottery-branch-counts', className)}>
			<p className="branch-counts-title">{t('Şubelere göre çekiliş hakların!')}</p>

			<ul className="branch-counts-list">
				{branches.map((branch) => (
					<li className="branch-counts-item" key={branch.id}>
						<Icon name="map-pin" className="item-icon" />
						<span className="item-title">{branch.title}</span>
						{loading ? (
							<Placeholder className="item-countplaceholder" />
						) : (
							<strong className="item-count">{branch.count}</strong>
						)}
					</li>
				))}
			</ul>
		</div>
	);
};

export default LotteryBranchCounts;
